import create, { UseStore } from "zustand";

export type ActivePanelOverrideStoreData = {
	hasOverride: boolean;
	doesOverrideContainDropOvers: boolean;
	registerOverride(): HTMLElement | null;
	clearOverride(): void;
	setHost(host: HTMLElement | null): void;
	setDoesOverrideContainDropOvers(value: boolean): void;
};

export const useActivePanelOverrideStore: UseStore<ActivePanelOverrideStoreData> = create<ActivePanelOverrideStoreData>(
	(set, get) => {
		const registerOverrideForHost = (host: HTMLElement | null): HTMLElement | null => {
			if (get().hasOverride) {
				throw new Error("Sidebar is already overridden");
			}

			set({hasOverride: true});

			return host;
		};

		return {
			hasOverride: false,
			doesOverrideContainDropOvers: false,
			registerOverride: () => registerOverrideForHost(null),
			clearOverride(): void {
				set({hasOverride: false});
			},
			setHost(host: HTMLElement | null): void {
				set({registerOverride: () => registerOverrideForHost(host)});
			},
			setDoesOverrideContainDropOvers(value: boolean): void {
				set({doesOverrideContainDropOvers: value});
			},
		};
	}
);